import React from 'react';
import { connect } from 'react-redux';
// LevelEditor imports
import PrefabCategories from './PrefabCategories';
import BtnBackground from './Buttons/btnBackground';
import BtnMoveMode from './Buttons/btnMoveMode';
import BtnCollapse from './btnCollapse';
import { RecentsCategoryString, BackgroundCategoryString } from '../../../../../../GameKit/shared';
import LibraryManager from '../../../../../../Game/Base/Library/LibraryManager';
import AssetRowPicker from '../../../../AssetRowPicker';

// Game(kit) imports
import AssetManager from '../../../../../../Game/Base/AssetManager';
import gameKit from '../../../../../../GameKit';

import { setHoveredPrefabName } from '../../../../../actions/levelEditorActions';

class ItemSelectorContainer extends React.Component {
    constructor(props) {
        super(props);

        this.buttonClassName = 'le-item-selector-extra-buttons';
    }

    getCurrentCategory = () => {
        const { levelEditor } = this.props;
        const currentCategory = levelEditor.itemSelectorCurrentCategory;
        return currentCategory;
    };

    getDescriptionTitle = () => {
        const { levelEditor } = this.props;
        const curCat = levelEditor.itemSelectorCurrentCategory;
        if (curCat === BackgroundCategoryString) {
            return 'Achter-grond';
        }
        return 'Bouw-stenen';
    };

    getCategoryDescription = () => {
        const { levelEditor } = this.props;
        const curCat = levelEditor.itemSelectorCurrentCategory;

        if (curCat === RecentsCategoryString) {
            return 'Bouwstenen die je al hebt gebruikt';
        }
        if (curCat === BackgroundCategoryString) {
            return 'Bewerk de achtergrond van je game';
        }

        const library = LibraryManager.prefabs;
        // Loop through categories
        for (let i = 0; i < library._categories.length; ++i) {
            if (curCat === library._categories[i].title) {
                return library._categories[i].description;
            }
        }
        return '';
    };

    getHoveredPrefabName = () => {
        const { levelEditor } = this.props;
        return levelEditor.hoveredPrefabName;
    };

    getAssetRowTextures = () => {
        const { levelEditor } = this.props;
        const currentCategory = levelEditor.itemSelectorCurrentCategory;
        let items = [];
        if (currentCategory === BackgroundCategoryString) {
            items = LibraryManager.textures._categories.map(c => c.getItems().map(i => ({ id: i.id, src: i.get().baseTexture.imageUrl }))).flat();
        } else if (currentCategory === RecentsCategoryString) {
            items = LibraryManager.recentPrefabs.map(recentItem => {
                const prefab = LibraryManager.prefabs.get(recentItem);
                return {
                    src: AssetManager.get(prefab.preview).baseTexture.source.src,
                    id: prefab.id,
                    name: prefab.name
                };
            });
        } else if (levelEditor.itemSelectorCurrentCategory.trim() !== '') {
            items = LibraryManager.prefabs._categories
                .find(c => c.title === currentCategory)
                .getItems()
                .map(i => ({ id: i.id, src: AssetManager.get(i.preview).baseTexture.source.src, name: i.name, previewHue: i.previewHue }));
        }

        return items;
    };

    handleItemClick = item => {
        const { levelEditor } = this.props;
        const currentCategory = levelEditor.itemSelectorCurrentCategory;

        if (currentCategory === BackgroundCategoryString) {
            gameKit.levelEditor.tileEditor.setBrushTexture(item.id);
        } else {
            gameKit.levelEditor.blokEditor.spawnPrefab(item.id);
        }
    };

    setHoveredPrefabName = name => {
        const { dispatch, levelEditor } = this.props;
        const currentCategory = levelEditor.itemSelectorCurrentCategory;
        if (currentCategory !== BackgroundCategoryString) {
            dispatch(setHoveredPrefabName(name));
        }
    };

    render = () => {
        const { levelEditor } = this.props;

        const activeClass = levelEditor.itemSelectorOpen ? 'active' : '';

        const currentCategory = levelEditor.itemSelectorCurrentCategory;

        return (
            <div className={`item-selector-wrapper ${activeClass}`}>
                <div className="item-selector-container">
                    <div className="item-selector-desc">
                        <p className="item-selector-mode-title">{this.getDescriptionTitle()}</p>
                        <p className="item-selector-category-desc">{this.getCategoryDescription()}</p>
                        <p className="item-selector-prefab-name">{this.getHoveredPrefabName()}</p>
                    </div>
                    <div className="item-selector-interactive">
                        <PrefabCategories />
                        <BtnBackground />
                        <BtnMoveMode />
                        <AssetRowPicker
                            items={this.getAssetRowTextures()}
                            active={currentCategory.trim() !== ''}
                            handleItemClick={this.handleItemClick}
                            setHoveredPrefabName={this.setHoveredPrefabName}
                            draggable={currentCategory !== BackgroundCategoryString}
                            currentCategory={this.getCurrentCategory()}
                            maxItemsInRow={9}
                        />
                    </div>
                </div>
                <BtnCollapse />
            </div>
        );
    };
}

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(mapStateToProps)(ItemSelectorContainer);
